import React from 'react';
import { Navigate } from 'react-router';

import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { CustomerDetailsTemplate } from '~/valleyBank/domains/Customers/ui/details/CustomerDetailsTemplate';
import { SummaryOverviewStatus } from '~/valleyBank/domains/Customers/ui/details/SummaryOverviewStatus';

// Exports
export const Route = () => (
  <RouteErrorBoundary
    fallback={({ message, showErrorToast }) => {
      showErrorToast(message);
      return <Navigate to="./" />;
    }}
  >
    <CustomerDetailsTemplate selectedTab="summary">
      <SummaryOverviewStatus />
    </CustomerDetailsTemplate>
  </RouteErrorBoundary>
);
